export default "__VITE_ASSET__bxm3LjQFnBVLF3cUf2nexw__"